"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationMapLinkContainer = exports.Separator = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.Separator = styled_1.default.span `
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
`;
exports.LocationMapLinkContainer = styled_1.default.span `
  white-space: nowrap;
`;
//# sourceMappingURL=styles.js.map